
export default {
  layout: 'default',

  head() {
    return {
      title: '使用者條款 - JaFun',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'JaFun 使用者條款，規範您使用 JaFun 平台及服務的相關約定。',
        },
      ],
    }
  },
}
